module.exports = __webpack_public_path__ + "static/img/titleImg3.e3baf4c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/titleImg3.png
// module id = tEXW
// module chunks = 0